import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../Helper/ToastMessage";

// Get Table Data
export const WorkAssignByOfficialsAPI = createAsyncThunk("WorkAssignByOfficials", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WorkTypeID,
        M_ZoneID,
        M_WardID,
        token,
        M_UserID,
        Flag,
        Language,
        handleGetCount,
        DashProjectTypeId,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url

    url = `${BaseUrl}/APKDashboard/Get_WEB_GD_OfficerWisePendingWorkStatus_Select?FromDate=${FromDate}&ToDate=${ToDate}&M_WorkTypeID=${M_WorkTypeID}&M_ZoneID=${M_ZoneID}&M_WardID=${M_WardID}&M_UserID=${M_UserID}&Language=Pending&Flag=${Flag}&From=1&To=99999`

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data && result.data.length > 0) {
                return result
            } else {
                return
            }
        })
        .catch((err) => {
            console.log("Error:", err)
            return err
        })
})

const Get_WEB_GD_OfficerWisePendingWorkStatus_Select = createSlice({
    name: "WorkAssignByOfficials",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WorkAssignByOfficialsAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WorkAssignByOfficialsAPI.fulfilled, (state, action) => {
            const { data } = action.payload;
            state.isLoading = false;
            state.tableData = data;

        });
        builder.addCase(WorkAssignByOfficialsAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const Get_WEB_GD_OfficerWisePendingWorkStatus_SelectReducer = Get_WEB_GD_OfficerWisePendingWorkStatus_Select.reducer
